import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const eldmandateConfig: TSPConfig = {
  key: 'eldmandate',
  name: 'ELD Mandate',
  category: TSPCategory.API_KEY,
  helpText: 'Please request an API key from your ELD Mandate representative.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default eldmandateConfig;
